export type AssetType =
  | 'brandingLogo'
  | 'brandingIcon'
  | 'contentImage'
  | 'contentSvg'
  | 'docsPdf';

export const assetAllowedMimeTypes: Record<AssetType, string[]> = {
  brandingLogo: ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'],
  brandingIcon: ['image/png', 'image/svg+xml'],
  contentImage: ['image/png', 'image/jpeg', 'image/webp', 'image/gif'],
  contentSvg: ['image/svg+xml'],
  docsPdf: ['application/pdf'],
};

export const assetImageMimeTypes: readonly string[] = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
  'image/svg+xml',
];

export interface AssetUploadResult {
  publicUrl: string;
  upload: {id: string; bucket: string; key: string; type: string};
  assetType: AssetType;
}
